import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="bg-bakery-cream py-24 px-6" data-id="element-127">
      <div className="max-w-3xl mx-auto text-center" data-id="element-128">
        <FadeIn data-id="element-129">
          <p className="text-2xl md:text-3xl font-serif italic text-bakery-brown leading-relaxed mb-10" data-id="element-130">
            "¿Alguna vez has entrado a un supermercado en Estados Unidos
            buscando ese aroma a pan recién horneado, solo para salir con una
            bolsa de pan de plástico que sabe a conservantes?"
          </p>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-131">
          <div className="w-16 h-1 bg-bakery-amber mx-auto mb-10 rounded-full" data-id="element-132"></div>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-133">
          <p className="text-lg md:text-xl text-bakery-brown/80 leading-relaxed" data-id="element-134">
            No es tu culpa no encontrar el sabor de casa. El problema es que las
            recetas de internet están diseñadas para expertos o usan medidas
            imprecisas que garantizan el fracaso del principiante.
          </p>
        </FadeIn>
      </div>
    </section>;
}